module.exports = __webpack_public_path__ + "img/img_works14.d1c67058.jpg";